import { Box, CircularProgress, Modal } from "@mui/material";
import React from "react";
import styled from "styled-components";
import { VStack } from "../Layouts/Stack";

type HorizontalProps = {
  open: boolean;
  text?: string;
};

const Div = styled.div`
  color: #fff;
  font-size: 24px;
`;

export const ProgressModal: React.VFC<HorizontalProps> = ({ open, text }) => {
  return (
    <Modal
      open={open}
      // onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          justifyContent: "center",
          display: "flex",
          alignItems: "center",
          alignContent: "center",
          width: "100%",
          height: "100%",
        }}
      >
        <VStack alignItems="center" justifyContent="center">
          {text ? <Div>{text}</Div> : <></>}
          <CircularProgress
            size={60}
            sx={{
              color: "#08daff",
            }}
          />
        </VStack>
      </Box>
    </Modal>
  );
};
